import { Link } from "react-router-dom";
import SEO from "../components/SEO";

export default function NotFoundPage() {
  return (
    <>
      <SEO title="Page Not Found | The Vantage Institute™" description="The page you are looking for does not exist." path="/404" />
      <section className="container-x py-24 text-center sm:py-32" data-testid="not-found">
        <p className="eyebrow">404</p>
        <h1 className="mt-4 font-display text-4xl font-semibold text-navy sm:text-5xl">This page has moved — or never existed.</h1>
        <p className="mx-auto mt-6 max-w-md text-base text-slate">
          The page you requested could not be found. Start again from the homepage or explore the programme catalogue.
        </p>
        <div className="mt-10 flex flex-col items-center justify-center gap-4 sm:flex-row">
          <Link to="/" className="btn-gold" data-testid="notfound-home">Back to Home</Link>
          <Link to="/programmes" className="btn-outline-navy" data-testid="notfound-programmes">Explore Programmes</Link>
        </div>
      </section>
    </>
  );
}
